import ResendEmailPage from "components/Forms/custom/ResendEmailPage";
import InfoLayout from "components/InfoLayout/InfoLayout";

const ResendEmail = () => {
  return <InfoLayout component={<ResendEmailPage />} />;
};

export default ResendEmail;
